const reviews = [
  { name: 'Marco R.', handle: '@marcorossi', avatar: 'MR', text: 'Finalmente ho trovato uno strumento organizzato per la mia ricerca prodotti. Itaobuy Spreadsheet mi ha fatto risparmiare ore ogni settimana.' },
  { name: 'Giulia B.', handle: '@giuliabianchi', avatar: 'GB', text: 'La guida in italiano &egrave; fantastica! Ho capito subito come funziona e ora uso Itaobuy Spreadsheet tutti i giorni per trovare nuove idee.' },
  { name: 'Alessandro F.', handle: '@alessandroferrari', avatar: 'AF', text: 'Le categorie sono ben organizzate e facili da navigare. Un must per chi cerca prodotti di qualit&agrave; senza perdere tempo.' },
  { name: 'Sofia M.', handle: '@sofiamoretti', avatar: 'SM', text: 'Aggiornamenti costanti e prodotti sempre nuovi. Itaobuy Spreadsheet &egrave; diventato il mio strumento preferito per lo shopping online.' },
  { name: 'Lorenzo D.', handle: '@lorenzodangelo', avatar: 'LD', text: 'Interfaccia pulita e intuitiva. Consiglio Itaobuy Spreadsheet a tutti i miei amici che vogliono trovare prodotti migliori.' },
  { name: 'Chiara V.', handle: '@chiaraverdi', avatar: 'CV', text: 'Non avrei mai pensato che uno spreadsheet potesse essere cos&igrave; utile. Itaobuy ha cambiato il mio modo di fare shopping.' },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 mb-4">
            <span className="text-xs font-medium text-secondary-700 uppercase tracking-wider">Cosa dicono gli utenti</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            Migliaia di utenti italiani
            <br />
            hanno gi&agrave; scelto Itaobuy Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[0, 1, 2].map((col) => (
            <div key={col} className="flex flex-col gap-5">
              {reviews.filter((_, i) => i % 3 === col).map((review) => (
                <div key={review.name} className="rounded-2xl bg-background-50 p-5">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-xs font-semibold text-accent-700">{review.avatar}</span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.handle}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{review.text}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}